import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: 3em;
    border-radius: ${theme.border.radius.small};
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.white};
    height: 100%;
  `}
`
export const TableTitle = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 36px;
  margin-top: 24px;
  margin-bottom: 8px;
`
export const Description = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 16px;
  margin-bottom: 32px;
`
